import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';

type LedDurum = 'acik' | 'kapali' | 'yanip-sonen';

@Component({
  selector: 'widget-led-gosterge',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span
      class="led"
      [class.yanip-sonen]="durum() === 'yanip-sonen'"
      [style.background]="gercekRenk()"
      [style.box-shadow]="golge()">
    </span>
  `,
  styles: [`
    :host { display: inline-flex; align-items: center; justify-content: center; }
    .led {
      width: 18px; height: 18px; border-radius: 50%;
      border: 1.5px solid rgba(255,255,255,0.1);
      transition: background 0.3s, box-shadow 0.3s;
    }
    .led.yanip-sonen { animation: led-blink 0.8s ease-in-out infinite; }
    @keyframes led-blink {
      0%, 100% { opacity: 1; }
      50% { opacity: 0.15; }
    }
  `],
})
export class LedGostergeComponent {
  durum = input<LedDurum>('kapali');
  renk = input('#52c41a');

  gercekRenk = computed(() => this.durum() === 'kapali' ? '#333' : this.renk());
  golge = computed(() => this.durum() === 'kapali' ? 'none' : `0 0 10px ${this.renk()}, 0 0 4px ${this.renk()}`);
}
